import { useEffect, useState } from 'react';
import ServiceSong from '../ServiceSong';
import { createSortable } from '../../utils/sorting';

import './ServiceSongs.scss';

function ServiceSongs({ currentService, songLengths, onDeleteFromService, onDragSortInService }) {
  const [serviceSongsRef, setServiceSongsRef] = useState(null);

  useEffect(() => {
    if (serviceSongsRef) {
      createSortable(serviceSongsRef, onDragSortInService);
    }
  }, [serviceSongsRef, onDragSortInService]);

  return (
    <ul ref={(ref) => setServiceSongsRef(ref)} className="ServiceSongs">
      {currentService.map((song) => (
        <ServiceSong
          key={song._id}
          song={song}
          seconds={songLengths?.get(song._id)}
          onDeleteSong={onDeleteFromService}
        />
      ))}
    </ul>
  );
}

export default ServiceSongs;
